import { BrowserRouter, Switch, Route } from 'react-router-dom';

import { Home } from './views/home';

import { SignUpStepFour } from './views/signUp';

import {
	OrderCheckout,
	OrderSending,
	OrderThanks,
	OrderRefused,
	OrderList,
	OrderDetails,
	OrderApproved,
} from './views/order';

import { PaymentError } from './views/paymentError';

import { Token } from './views/token';

import { Ccb } from './views/ccb';

import {
	KycBankExt,
	KycContacts,
	KycDocBack,
	KycDocFront,
	KycRedirect,
	KycSelfie,
	KycThanks,
} from './views/kyc';

import { CouponList } from './views/coupon';

import { OrderEmailValidation } from './views/emailValidation';

import { NotFound } from './views/notFound';

import {
	PrivateRoute,
	TransactionRoute,
	LoginRedirect,
	RegisterRedirect,
} from './shared/components/index';

import './main.scss';

import dotenv from 'dotenv';
dotenv.config();

export default function Routes() {
	return (
		<BrowserRouter>
			<Switch>
				<Route path="/auth/:id" exact component={LoginRedirect} />
				<Route path="/taker/register" exact component={RegisterRedirect} />
				<PrivateRoute
					path="/taker/register/finish"
					exact
					component={SignUpStepFour}
				/>
				<PrivateRoute path="/taker" exact component={Home} />
				<PrivateRoute path="/taker/order/add" exact component={OrderSending} />
				<TransactionRoute
					path="/taker/order/:id/accept"
					exact
					component={OrderCheckout}
				/>
				<TransactionRoute
					path="/taker/order/:id/token"
					exact
					component={Token}
				/>
				<TransactionRoute
					path="/taker/order/:id/signature"
					exact
					component={Ccb}
				/>
				<TransactionRoute
					path="/taker/order/:id/formalizacao"
					exact
					component={KycRedirect}
				/>
				<TransactionRoute
					path="/taker/order/:id/formalizacao/selfie"
					exact
					component={KycSelfie}
				/>
				<TransactionRoute
					path="/taker/order/:id/formalizacao/doc_front"
					exact
					component={KycDocFront}
				/>
				<TransactionRoute
					path="/taker/order/:id/formalizacao/doc_back"
					exact
					component={KycDocBack}
				/>
				<TransactionRoute
					path="/taker/order/:id/formalizacao/bank_ext"
					exact
					component={KycBankExt}
				/>
				<TransactionRoute
					path="/taker/order/:id/formalizacao/contacts"
					exact
					component={KycContacts}
				/>
				<TransactionRoute
					path="/taker/order/:id/formalizacao/thanks"
					exact
					component={KycThanks}
				/>
				<TransactionRoute
					path="/taker/order/:id/thanks"
					exact
					component={OrderThanks}
				/>
				<TransactionRoute
					path="/taker/order/:id/refused"
					exact
					component={OrderRefused}
				/>
				<TransactionRoute
					path="/taker/order/:id/approved"
					exact
					component={OrderApproved}
				/>
				{process.env.REACT_APP_ENVIRONMENT !== 'PROD' ? (
					<PrivateRoute
						path="/taker/order/:id/payment-error"
						exact
						component={PaymentError}
					/>
				) : (
					''
				)}

				<PrivateRoute path="/taker/order" exact component={OrderList} />
				<PrivateRoute path="/taker/order/:id" exact component={OrderDetails} />

				<PrivateRoute path="/taker/coupon" exact component={CouponList} />

				<TransactionRoute
					path="/taker/order/:id/email/validation"
					exact
					component={OrderEmailValidation}
				/>

				<Route component={NotFound} />
			</Switch>
		</BrowserRouter>
	);
}
